import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Grid } from '@mui/material';
import {debounce} from 'lodash'
import {
  addCompany,
  clearCompanyDetails,
  fetchParentCompanyDetails,
  fetchParentCompanys,
} from 'redux/actions/companyAction';
import { getServiceCity } from 'redux/actions/UserServiceCity';
import CommonMultiForm from 'components/commonMultiForm/CommonMultiForm';
import BackDrop from 'components/backDrop/BackDrop';
import { optionsList } from 'utils/utils';
import { formData } from './CompanyData';

const CompanyOnboarding = (props) => {
  const [contractDetails, setContractDetails] = useState(true);
  const [skipClicked, setSkipClicked] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;

  const cityList = useSelector(
    (state) => state?.userServiceCity?.userServiceCity?.data
  );
  const onboardedCompanyData = useSelector(
    (state) => state?.addCompany?.onBoardedCompay?.data
  );

  const updateOnboardedCompanyDatas = useSelector(
    (state) => state?.updateCompany?.onBoardedCompay?.data
  );

  const parentCompanyList = useSelector(
    (state) => state?.parentCompanyList?.parentCompanyList?.body
  );
  const parentCompanyListLoader = useSelector(
    (state) => state?.parentCompanyList?.loading
  );

  const cityListLoader = useSelector(
    (state) => state?.userServiceCity?.userServiceCity?.success
  );

  useEffect(() => {
    dispatch(getServiceCity());
    dispatch(fetchParentCompanys());
    dispatch(clearCompanyDetails());

    return () => {
      dispatch(clearCompanyDetails());
    };
  }, [dispatch]);

  const parentID = (onboardedCompanyData?.parentCompanyId || updateOnboardedCompanyDatas?.parentCompanyId || state?.companyProfile?.parentCompanyId)

  useEffect(() => {
    if(parentID) {
      dispatch(fetchParentCompanyDetails({id: parentID}));
    }
  }, [parentID, dispatch])
  

  const cityOption = optionsList(cityList, 'cityOption');
  const parentCompanyListOption = optionsList(
    parentCompanyList,
    'parentCompanyList'
  );

  const onScrollTop = () => {
    const element = document.getElementsByClassName('formDiv');
    element[0].scroll({
      top: 0,
      behavior: 'smooth',
    });
  };

  //onsubmit contract details
  const onSubmitContractDetails = (
    data,
    image,
    country,
    cities,
    e,
    selectedMultiFiles,
    deleteFileId,
    dynamicDomain
  ) => {
    // For new company, send simplified JSON payload
    const companyPayload = {
      allowedDomain: dynamicDomain?.map(d => d[`allowedDomain-0`]) || [],
      name: data?.name,
      address: data?.address,
      cityId: data?.cityId,
      pinCode: data?.pinCode,
      panNumber: data?.panNumber,
      email: data?.email,
      phoneNumber: data?.phoneNumber,
      countryCode: country,
      adminName: data?.adminName,
    };

    dispatch(addCompany(companyPayload, setContractDetails, navigate));
    onScrollTop()
  };

  //onsubmit gst billing details
  // const onSubmitaCompanyGst = (data, image, country, commonSwitch) => {
  //   if (state?.edit) {
  //     const gstData = {
  //       id: state?.companyProfile.id,
  //       isParentAdmin: commonSwitch?.admin,
  //       isParentFinance: commonSwitch?.finance,
  //       admin: {
  //         name: data?.adminName ? data?.adminName : 'name',
  //         countryCode: country,
  //         mobileNumber: data?.phoneNumber,
  //         email: data?.adminEmail,
  //       },
  //       finance: {
  //         name: data?.financeName,
  //         countryCode: country,
  //         mobileNumber: data?.mobileNumber,
  //         email: data?.financeEmail,
  //       },
  //     };

  //     dispatch(updateCompanyGst(gstData, navigate));
  //   } else {
  //     const gstData = {
  //       companyId: onboardedCompanyData?.id,
  //       isParentAdmin: commonSwitch?.admin || false,
  //       isParentFinance: commonSwitch?.finance || false,
  //       admin: {
  //         name: data?.adminName ? data?.adminName : 'name',
  //         countryCode: country,
  //         mobileNumber: data?.phoneNumber,
  //         email: data?.adminEmail,
  //       },
  //       finance: {
  //         countryCode: country,
  //         name: data?.financeName,
  //         mobileNumber: data?.mobileNumber,
  //         email: data?.financeEmail,
  //       },

  //     };
  //     dispatch(addCompanyGst(gstData, navigate));
  //   }
  //   onScrollTop()
  // };

  const handleNavigate = () => {
    if (contractDetails) {
      navigate('/companies', { replace: true });
    } else {
      setContractDetails(true);
      navigate('/companies/new-booking', {
        state: {
          edit: true,
          companyProfile: state?.edit
          ? (skipClicked ? onboardingDefaultValues : updateOnboardedCompanyDatas)
          : onboardedCompanyData,
        },
      });
    }
  };

  let values = state?.companyProfile;

  const companyProfile = {
    ...state?.companyProfile,
    parentCompanyId: state?.companyProfile?.parentCompanyId && {
      value: state?.companyProfile?.parentCompanyId,
      label: state?.companyProfile?.parentCompanyName,
    },
    tenure: [values?.Contracts?.[0].startDate, values?.Contracts?.[0].endDate],
    billingDetails: state?.companyProfile?.Contracts?.[0]?.billingType && true,
    billingType: state?.companyProfile?.Contracts?.[0]?.billingType,
    billToCreditCard:
      (state?.companyProfile?.Contracts?.[0]?.billingType === 1 ||
        state?.companyProfile?.Contracts?.[0]?.billingType === 3) &&
      'billToCreditCard',
    billToCompany:
      (state?.companyProfile?.Contracts?.[0]?.billingType === 2 ||
        state?.companyProfile?.Contracts?.[0]?.billingType === 3) &&
      'billToCompany',
    approvalDuration : state?.companyProfile?.Contracts?.[0]?.approvalDuration,
    billingCycle : state?.companyProfile?.Contracts?.[0]?.billingCycle,
    invoiceType : state?.companyProfile?.Contracts?.[0]?.invoiceType,
    config : state?.companyProfile?.Contracts?.[0]?.config,
    configRate : state?.companyProfile?.Contracts?.[0]?.configRate,
    endOtpRequired: state?.companyProfile?.endOtpRequired || false,
    ...(values?.additionalInfo ? values?.additionalInfo : {})
  };

  const onboardingDefaultValues = state?.edit ? companyProfile : '';

  const btnAction = () => {
    setContractDetails(false)
    setSkipClicked(true);
  }

  const onHandleAutoSuggestion = debounce((event, value, fieldName) => {
    if(fieldName === "parentCompanyName") {
        dispatch(fetchParentCompanys({search: value}, {searchType: "globalSearch", loader: "backDropLoader"}));
      }
  }, 500);

  const onboardingTitle = state?.edit ? "Edit Company" : "Add new company"
  const companyTitles = ["Edit Company", "Add new company", "Admin Team Details"]

  return (
    <Grid container className="pt20 br20" justifyContent={'center'}>
      <Grid item xs={11} lg={11} className="p30 mb20  bgLightWhite">
        {cityListLoader && !parentCompanyListLoader ? (
          <Box>
            {contractDetails && (
                <CommonMultiForm
                  formData={formData(
                    parentCompanyListOption,
                    cityOption,
                    values,
                    onboardingTitle,
                    state?.edit 
                  )}
                  companyEdit={state?.edit && true}
                  formType={'companyOnbaording'}
                  onSubmittBtn={onSubmitContractDetails}
                  handleNavigate={handleNavigate}
                  companyTitles={companyTitles}
                  button={'Submit'}
                  cityList={cityList}
                  defaultValues={onboardingDefaultValues}
                  onHandleAutoSuggestion={onHandleAutoSuggestion}
                  btnAction={btnAction}
                />
            )}

            {/* {!contractDetails && (
              <>
                <CommonMultiForm
                  formData={f}
                  onSubmittBtn={onSubmitaCompanyGst}
                  button={
                    adminData?.[0]?.name
                      ? 'Update'
                      : 'Submit'
                  }
                  contractId={onboardedCompanyData?.Contracts?.[0]?.Agreements?.[0]?.contractId || onboardingDefaultValues?.Contracts?.[0]?.CompanyContracts?.ContractId || onboardedCompanyData?.agreement?.contractId || updateOnboardedCompanyDatas?.Contracts?.[0]?.CompanyContracts?.ContractId}
                  defaultValues={gstDetails}
                  rateCard={true}
                  companyEdit={state?.edit && true}
                  companyPage={"companyGst"}
                  companyEmail={state?.edit
                    ? (skipClicked ? onboardingDefaultValues : updateOnboardedCompanyDatas)
                    : onboardedCompanyData}
                    handleNavigate={handleNavigate}
                    companyTitles={companyTitles}
                    formName='companyAdminFinance'
                    hasParentFinance={hasParentFinance}
                    hasParentAdmin={hasParentAdmin}
                    switchDisable={switchDisable}
                    parentCompanyAdminDetails={parentCompanyAdminDetails}
                />
              </>
            )} */}
          </Box>
        ) : (
          <BackDrop type="company" />
        )}
      </Grid>
    </Grid>
  );
};

export default CompanyOnboarding;